import {pxToRem} from '../../utills/pxToRem'

export const containerStyle = {
    pb: pxToRem(80)
}

export const headingStyle = {
    fontSize: {base: pxToRem(18), md: pxToRem(22)},
    fontWeight: 600,
    color: 'black',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    lineHeight: 'normal',
    mb: {base: pxToRem(28), md: pxToRem(35)}
}

export const bodyStyle = {
    position: 'relative',
    overflow: 'hidden'
}

const createArrowContainerStyle = (position) => ({
    pos: 'absolute',
    top: {base: '35.5%', md: '41%'},
    zIndex: 10,
    w: {base: pxToRem(30), md: pxToRem(40)},
    h: {base: pxToRem(30), md: pxToRem(40)},
    cursor: 'pointer',
    [position]: {base: pxToRem(0), md: pxToRem(30)},
    '& > svg:first-of-type': {
        display: 'block'
    },
    '& > svg:last-of-type': {
        display: 'none'
    },
    '&:hover': {
        '& > svg:first-of-type': {
            display: 'none'
        },
        '& > svg:last-of-type': {
            display: 'block'
        }
    }
})

export const arrowContainerLeftStyle = createArrowContainerStyle('left')
export const arrowContainerRightStyle = createArrowContainerStyle('right')

const iconStyle = {
    w: '100%',
    h: '100%'
}

export const iconButtonLeftStyle = {
    ...iconStyle,
    transform: 'rotate(180deg)'
}

export const iconButtonLeftHoverStyle = iconButtonLeftStyle

export const iconButtonRightStyle = iconStyle

export const iconButtonRightHoverStyle = iconStyle

export const scrollContainerStyle = {
    gap: 4,
    overflowX: 'auto',
    overflowY: 'hidden',
    w: '100%',
    '&::-webkit-scrollbar': {display: 'none'},
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    scrollBehavior: 'smooth'
}

const tileStyle = {
    flex: {base: '0 0 47.8%', md: '0 0 23.59%'}
}

export const skeletonBoxStyle = tileStyle

export const recBoxStyle = tileStyle

export const skeletonForAddToCart = {
    flex: {base: '0 0 50%', md: '0 0 37.7%'}
}
export const recBoxStyleForAddToCart = {
    flex: {base: '0 0 50%', md: '0 0 37.7%'}
}
